<template>
  <PaymentInfo
    :payment-icons="paymentIcons"
    :label="
      $textDictionary['cart.label.payments.payingsafe'] ??
      'cart.label.payments.payingsafe'
    "
    :extended-details-icon="
      $textDictionary['cart.label.payments.payingsafeIcon'] ?? 'certify'
    "
    :extended-details-text="$textDictionary['actionBar.paymentDetails']"
    :show-extended-details="true"
    :background-color="backgroundColor ?? undefined"
  >
  </PaymentInfo>
</template>

<script setup lang="ts">
import { PaymentInfo } from '@hypercodestudio/basler-components';

interface Props {
  backgroundColor?: string;
}

defineProps<Props>();
const { paymentIcons } = useBadges('trust');
const { $textDictionary } = useNuxtApp();
</script>

<style scoped></style>
